<div class="upgrade-msg-container">
  <!-- Details of failure -->
  <div *ngIf="requestFailed() && !isLoading()">
    <div class="status">
      <div class="agent-icon">
        <mat-icon class="agent-failure">highlight_off</mat-icon>
      </div>
    </div>
    <div class="status-message">
      <p><b>{{failureMsg}}</b></p>
      <div>{{wizardCtrl.wizardService.errorMessage}}</div>
    </div>
  </div>

  <!-- Details of success -->
  <div *ngIf="!requestFailed() && !isLoading()">
    <div class="status">
      <div class="agent-icon">
        <mat-icon class="success">check_circle_outline</mat-icon>
      </div>
      <div class="status-message">
        <p><b>{{successMsg}}</b></p>
        <div>{{successDescription}}</div>
      </div>
    </div>
  </div>
</div>
